import React, { useEffect, useState } from "react";
import { Modal, Button, Form, Card, Row, Col, Badge } from "react-bootstrap";
import { useDropzone } from "react-dropzone";
import { useDispatch, useSelector } from "react-redux";
import Cropper from "react-easy-crop";
import {
  onBanner,
  onBannerAdd,
  onBannerDelete,
  onOfers,
} from "../../redux/homeAction";

const Banner = () => {
  const dispatch = useDispatch();

  const [show, setShow] = useState(false);
  const [edit, setEdit] = useState(null);

  const [offerId, setOfferId] = useState("");
  const [placement, setPlacement] = useState("home");
  const [priority, setPriority] = useState(0);
  const [offers, setOffers] = useState([]);

  const [clickType, setClickType] = useState("search");
  const [clickValue, setClickValue] = useState("");

  // --- SEPARATE STATES FOR DESKTOP & MOBILE ---
  const [desktopSrc, setDesktopSrc] = useState(null);
  const [mobileSrc, setMobileSrc] = useState(null);

  const [desktopCrop, setDesktopCrop] = useState({ x: 0, y: 0 });
  const [desktopZoom, setDesktopZoom] = useState(1);
  const [desktopPixels, setDesktopPixels] = useState(null);

  const [mobileCrop, setMobileCrop] = useState({ x: 0, y: 0 });
  const [mobileZoom, setMobileZoom] = useState(1);
  const [mobilePixels, setMobilePixels] = useState(null);

  const banners = useSelector((state) => state.home.getBanner);
  const getOffers = useSelector((state) => state.home.getOffers);

  useEffect(() => {
    dispatch(onBanner());
    dispatch(onOfers(setOffers));
  }, []);

  useEffect(() => {
    if (getOffers) setOffers(getOffers);
  }, [getOffers]);

  const openModal = (b = null) => {
    setEdit(b);
    setOfferId(b?.campaignId || "");
    setPlacement(b?.placement || "home");
    setPriority(b?.priority || 0);
    setClickType(b?.clickAction?.type || "search");
    setClickValue(b?.clickAction?.value || "");

    setDesktopSrc(null);
    setMobileSrc(null);
    setDesktopPixels(null);
    setMobilePixels(null);
    setShow(true);
  };

  // Canvas Worker function (Saves on-the-fly lagging)
  const getCroppedImg = (imageSrc, croppedAreaPixels) => {
    return new Promise((resolve) => {
      const image = new Image();
      image.src = imageSrc;
      image.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        canvas.width = croppedAreaPixels.width;
        canvas.height = croppedAreaPixels.height;
        ctx.drawImage(
          image,
          croppedAreaPixels.x,
          croppedAreaPixels.y,
          croppedAreaPixels.width,
          croppedAreaPixels.height,
          0,
          0,
          croppedAreaPixels.width,
          croppedAreaPixels.height,
        );
        canvas.toBlob((blob) => resolve(blob), "image/webp", 0.9);
      };
    });
  };

  const submit = async () => {
    const fd = new FormData();

    // Trigger cropping only ON SUBMIT (Myntra fast processing approach)
    if (desktopSrc && desktopPixels) {
      const dtBlob = await getCroppedImg(desktopSrc, desktopPixels);
      fd.append("desktop", dtBlob, "desktop.webp");
    }
    if (mobileSrc && mobilePixels) {
      const mbBlob = await getCroppedImg(mobileSrc, mobilePixels);
      fd.append("mobile", mbBlob, "mobile.webp");
    }

    fd.append("offerId", offerId);
    fd.append("placement", placement);
    fd.append("priority", priority);
    fd.append("clickType", clickType);
    fd.append("clickValue", clickValue);

    dispatch(onBannerAdd(fd, setShow));
  };

  const { getRootProps: getDesktopProps, getInputProps: getDesktopInput } =
    useDropzone({
      onDrop: (files) => setDesktopSrc(URL.createObjectURL(files[0])),
      multiple: false,
      accept: { "image/*": [] },
    });

  const { getRootProps: getMobileProps, getInputProps: getMobileInput } =
    useDropzone({
      onDrop: (files) => setMobileSrc(URL.createObjectURL(files[0])),
      multiple: false,
      accept: { "image/*": [] },
    });

  // ... baaki saara code same rahega, bas return statement ke andar ye changes hain ...

  return (
    <div
      className="container mt-4"
      style={{
        backgroundColor: "#f8f9fa",
        minHeight: "100vh",
        padding: "20px",
      }}
    >
      {/* HEADER SECTION */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h3 style={{ fontWeight: "700", color: "#282c3f" }}>
            Myntra Banner Campaign Manager
          </h3>
          <p className="text-muted m-0">
            Create and schedule curated banner workflows
          </p>
        </div>
        <Button
          style={{
            backgroundColor: "#ff3f6c",
            border: "none",
            padding: "10px 20px",
            fontWeight: "600",
          }}
          onClick={() => openModal()}
        >
          + Create New Campaign
        </Button>
      </div>

      {/* BANNER GRID */}
      <Row>
        {banners?.banners?.map((b) => (
          <Col md={4} key={b._id} className="mb-4">
            <Card
              className="border-0 shadow-sm"
              style={{ borderRadius: "10px", overflow: "hidden" }}
            >
              <div style={{ position: "relative", backgroundColor: "#f5f5f6" }}>
                {/* DESKTOP PREVIEW: objectFit contain lagaya taaki image distort na ho */}
                <Card.Img
                  src={b.image?.desktop?.url}
                  style={{
                    height: "140px",
                    objectFit: "contain",
                    backgroundColor: "#f5f5f6",
                  }}
                />
                {/* MOBILE PREVIEW STICKER */}
                <div
                  style={{
                    position: "absolute",
                    bottom: "-20px",
                    right: "15px",
                    width: "55px",
                    height: "75px",
                    borderRadius: "5px",
                    overflow: "hidden",
                    border: "2px solid white",
                    boxShadow: "0px 2px 8px rgba(0,0,0,0.15)",
                    backgroundColor: "#f5f5f6",
                  }}
                >
                  <img
                    src={b.image?.mobile?.url}
                    alt="mobile"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                    }}
                  />
                </div>
              </div>
              <Card.Body className="pt-4">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <Badge style={{ backgroundColor: "#fe9e2d" }}>
                    {b.placement.toUpperCase()}
                  </Badge>
                  <Badge bg="dark">Priority: {b.priority}</Badge>
                </div>
                <p className="text-muted small mb-3">
                  <strong>Action:</strong> {b.clickAction?.type} →{" "}
                  {b.clickAction?.value || "N/A"}
                </p>
                <div className="d-flex gap-2">
                  <Button
                    size="sm"
                    variant="outline-secondary"
                    className="w-100"
                    onClick={() => openModal(b)}
                  >
                    Edit
                  </Button>
                  <Button
                    size="sm"
                    variant="danger"
                    className="w-100"
                    style={{ backgroundColor: "#d11a2a" }}
                    onClick={() => dispatch(onBannerDelete(b._id))}
                  >
                    Delete
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      {/* CREATION MODAL */}
      <Modal show={show} onHide={() => setShow(false)} size="xl" centered>
        <Modal.Header closeButton style={{ borderBottom: "1px solid #f5f5f6" }}>
          <Modal.Title style={{ fontWeight: "700", color: "#282c3f" }}>
            {edit ? "Modify Campaign Banner" : "Setup New Campaign Banner"}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ backgroundColor: "#f9f9f9" }}>
          <Row>
            {/* LEFT: IMAGE CROPPERS */}
            <Col lg={8}>
              <Card className="p-3 border-0 shadow-sm mb-3">
                <h6 className="fw-bold mb-3 text-secondary">
                  1. Banner Assets
                </h6>
                <Row>
                  {/* DESKTOP CROPPER */}
                  <Col md={6}>
                    <label className="form-label small fw-bold">
                      Desktop Asset (1920×600)
                    </label>
                    <div
                      {...getDesktopProps()}
                      className="border-dashed text-center p-3 mb-2"
                      style={{
                        border: "2px dashed #d5d6d8",
                        background: "#fff",
                        cursor: "pointer",
                        borderRadius: "8px",
                      }}
                    >
                      <input {...getDesktopInput()} />
                      {!desktopSrc ? (
                        <p className="text-muted m-0 small py-4">
                          Drag/Click to upload Desktop Banner
                        </p>
                      ) : (
                        <p className="text-success m-0 small fw-bold">
                          ✓ Desktop Image Loaded
                        </p>
                      )}
                    </div>
                    {desktopSrc && (
                      <div
                        style={{
                          height: 250,
                          position: "relative",
                          background: "#000",
                          borderRadius: "8px",
                          overflow: "hidden",
                        }}
                      >
                        <Cropper
                          image={desktopSrc}
                          crop={desktopCrop}
                          zoom={desktopZoom}
                          aspect={1920 / 800} // 👈 UPDATE: Naya Myntra Ratio (1920x800)
                          onCropChange={setDesktopCrop}
                          onZoomChange={setDesktopZoom}
                          onCropComplete={(_, px) => setDesktopPixels(px)}
                        />
                      </div>
                    )}
                  </Col>

                  {/* MOBILE CROPPER */}
                  <Col md={6}>
                    <label className="form-label small fw-bold">
                      Mobile Asset (1200×600)
                    </label>
                    <div
                      {...getMobileProps()}
                      className="border-dashed text-center p-3 mb-2"
                      style={{
                        border: "2px dashed #d5d6d8",
                        background: "#fff",
                        cursor: "pointer",
                        borderRadius: "8px",
                      }}
                    >
                      <input {...getMobileInput()} />
                      {!mobileSrc ? (
                        <p className="text-muted m-0 small py-4">
                          Drag/Click to upload Mobile Banner
                        </p>
                      ) : (
                        <p className="text-success m-0 small fw-bold">
                          ✓ Mobile Image Loaded
                        </p>
                      )}
                    </div>
                    {mobileSrc && (
                      <div
                        style={{
                          height: 250,
                          position: "relative",
                          background: "#000",
                          borderRadius: "8px",
                          overflow: "hidden",
                        }}
                      >
                        <Cropper
                          image={mobileSrc}
                          crop={mobileCrop}
                          zoom={mobileZoom}
                          aspect={1920 / 800} // 👈 800x1000 is perfect vertical feed
                          onCropChange={setMobileCrop}
                          onZoomChange={setMobileZoom}
                          onCropComplete={(_, px) => setMobilePixels(px)}
                        />
                      </div>
                    )}
                  </Col>
                </Row>
              </Card>
            </Col>

            {/* RIGHT: METADATA CONTROLS */}
            <Col lg={4}>
              <Card className="p-3 border-0 shadow-sm">
                <h6 className="fw-bold mb-3 text-secondary">
                  2. Campaign Actions & Triggers
                </h6>
                {/* ... (Form.Group controls bilkul same rahenge aapke code jaise) ... */}
                <Form.Group className="mb-3">
                  <Form.Label className="small fw-bold">
                    Click Action Type
                  </Form.Label>
                  <Form.Select
                    value={clickType}
                    onChange={(e) => setClickType(e.target.value)}
                  >
                    <option value="search">Search Term Query</option>
                    <option value="category">Category Landing Page</option>
                    <option value="url">External / Custom URL</option>
                  </Form.Select>
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label className="small fw-bold">
                    Target Value (URL/Query/ID)
                  </Form.Label>
                  <Form.Control
                    value={clickValue}
                    onChange={(e) => setClickValue(e.target.value)}
                    placeholder="e.g., shirts, /men-jackets, ext_id"
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label className="small fw-bold">
                    Select Offer
                  </Form.Label>
                  <Form.Select
                    value={offerId}
                    onChange={(e) => setOfferId(e.target.value)}
                  >
                    {offers &&
                      offers?.map((data, i) => (
                        <option key={i} value={data?._id}>
                          {data?.title}
                        </option>
                      ))}
                  </Form.Select>
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label className="small fw-bold">
                    Page Placement
                  </Form.Label>
                  <Form.Select
                    value={placement}
                    onChange={(e) => setPlacement(e.target.value)}
                  >
                    <option value="home">Main Homepage Grid</option>
                    <option value="category">Category Header</option>
                    <option value="product">Product Details Sidebar</option>
                  </Form.Select>
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label className="small fw-bold">
                    Priority Rank
                  </Form.Label>
                  <Form.Control
                    type="number"
                    value={priority}
                    onChange={(e) => setPriority(e.target.value)}
                    placeholder="Higher rank shows first (e.g. 10)"
                  />
                </Form.Group>
              </Card>
            </Col>
          </Row>
        </Modal.Body>

        <Modal.Footer style={{ borderTop: "1px solid #f5f5f6" }}>
          <Button variant="light" onClick={() => setShow(false)}>
            Cancel
          </Button>
          <Button
            style={{
              backgroundColor: "#ff3f6c",
              border: "none",
              fontWeight: "600",
            }}
            onClick={submit}
          >
            {edit ? "Update & Push Live" : "Deploy Campaign"}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Banner;
